import {
  formatGovernmentBondPriceIn32nds,
  getManualTradeDecimalPrice,
  roundGovernmentBondDecimalPriceToNearest32nd,
} from '@src/utils/governmentBondPrice';
import { format, type Security } from '@talos/kyoko';
import Big from 'big.js';

export function getManualTradeBondAmount(
  quantity: string,
  price: string,
  security: Security | undefined,
  useGovernmentBond32ndsInput: boolean
): string {
  const decimalPrice = getManualTradeDecimalPrice(price, security, useGovernmentBond32ndsInput);
  if (decimalPrice == null || decimalPrice === '') {
    return '0';
  }

  return Big(quantity).times(decimalPrice).div(100).toFixed();
}

export function getManualTradeBondQuantity(
  amount: string,
  price: string,
  security: Security | undefined,
  useGovernmentBond32ndsInput: boolean,
  minSizeIncrement: string | undefined
): string {
  const decimalPrice = getManualTradeDecimalPrice(price, security, useGovernmentBond32ndsInput);
  if (decimalPrice == null || decimalPrice === '' || Big(decimalPrice).eq(0)) {
    return '0';
  }

  return format(Big(amount).times(100).div(decimalPrice).toFixed(), {
    spec: minSizeIncrement,
    pretty: false,
  });
}

export function getManualTradeBondPrice(
  quantity: string,
  amount: string,
  useGovernmentBond32ndsInput: boolean,
  minPriceIncrement: string | undefined
): string {
  if (Big(quantity).eq(0)) {
    return '0';
  }

  const rawDecimalPrice = Big(amount).times(100).div(quantity);
  const decimalPrice = useGovernmentBond32ndsInput
    ? roundGovernmentBondDecimalPriceToNearest32nd(rawDecimalPrice)
    : rawDecimalPrice;

  if (useGovernmentBond32ndsInput) {
    return formatGovernmentBondPriceIn32nds(decimalPrice);
  }

  return format(decimalPrice.toFixed(), { spec: minPriceIncrement, pretty: false });
}
